module.exports = __webpack_public_path__ + "static/media/17UN-Women5.956f8c18.jpg";